<template>
  <div v-if="party" class="forms-elements">
    <Breadcrumbs v-bind:breadcrumbs="breadcrumbs" />

    <Widget v-if="party">
      <PartyForm :party="party" @update:party="partyLocalUpdate" @save="handleSave" />

      <b-row>
        <b-col lg="12" md="12" sm="12">
          <ButtonBar
            :showDeleteButton="buttons.showDeleteButton"
            :model="party"
            modelEditRoute="PartyEditPage"
            modelListRoute="PartiesPage"
            modelRouteParamName="partyNumber"
            :updateCallback="updateParty"
            :createCallback="createParty"
            :deleteCallback="deleteParty"
            :fetchPaginatedCallback="fetchPartiesPaginated"
          />
        </b-col>
      </b-row>
    </Widget>
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget';
import Breadcrumbs from '@/components/Breadcrumbs';
import { mapGetters, mapActions } from 'vuex';
import ButtonBar from '@/components/ButtonBar.vue';
import PartyForm from '@/components/Parties/PartyForm.vue';

export default {
  name: 'PartyEditPage',
  components: {
    Widget,
    Breadcrumbs,
    ButtonBar,
    PartyForm,
  },
  props: {
    partyNumber: {
      type: [String, Number],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      number: null,
    };
  },
  computed: {
    ...mapGetters(['getPartyByNumber']),
    buttons() {
      return {
        showDeleteButton: this.party && this.party.number !== '_new',
      };
    },
    party() {
      return this.getPartyByNumber(this.number);
    },
    breadcrumbs() {
      return [
        { name: 'Home', route: { name: 'home' } },
        { name: this.$t('parties'), route: { name: 'PartiesPage' } },
        {
          name: this.party && this.party.number !== '_new' ? this.$t('edit') : this.$t('new'),
        },
      ];
    },
  },
  methods: {
    ...mapActions([
      'fetchPartiesPaginated',
      'fetchPartyByNumber',
      'updateParty',
      'createParty',
      'deleteParty',
      'initParty',
      'partyLocalUpdate',
    ]),

    async handleSave(party) {
      if (party.number === '_new') {
        const newNumber = await this.createParty(party);
        this.$router.replace({
          name: 'PartyEditPage',
          params: { partyNumber: newNumber },
        });
      } else {
        await this.updateParty(party);
      }
    },
  },
  async mounted() {
    const isCreate = this.$route.name === 'PartyCreatePage' || this.partyNumber == null;
    if (isCreate) {
      await this.initParty();
      this.number = '_new';
    } else {
      this.number = this.partyNumber;
      await this.fetchPartyByNumber(this.number);
    }
  },
};
</script>

<style scoped lang="scss">
.p-calendar {
  width: 100%;
}
</style>
